import { Component, input, Input, OnInit } from '@angular/core';
import { AppGlobalsModule } from 'src/app/app-globals.module';
import { SiteLocations } from 'src/app/core/services/url-address/url-address.service';

@Component({
    selector: 'main-menu-link',
    templateUrl: './main-menu-link.component.html',
    styleUrls: ['./main-menu-link.component.scss'],
    standalone: false,
})
export class MainMenuLinkComponent implements OnInit {
    activeLocation = input<SiteLocations | null>(null);
    @Input() isAngularApp: boolean = false;
    public SiteLocations = SiteLocations;
    public android = false;

    constructor() {}

    ngOnInit(): void {
        if (AppGlobalsModule.AndroidApp) {
            this.android = true;
        }
    }
}
